import { addFilter } from '@wordpress/hooks'
import { useSelect, dispatch } from '@wordpress/data'
import { PanelRow, TextControl, ToggleControl } from '@wordpress/components'
import { __ } from '@wordpress/i18n'

/**
 * Adding PayHere Content
 */
addFilter( 'wp_travel_payment_gateway_fields_payhere', 'wp-travel', (content) => {
    return [ ...content, <PayHereContent /> ]
});

const PayHereContent = () => {

    /**
     * Get Store Settings.
     */
    const { updateSettings } = dispatch('WPTravel/Admin');

    const allData = useSelect( (select) => {
        return select('WPTravel/Admin').getAllStore()
    }, [] );

    const {
        wp_travel_payhere_settings,
        wt_test_mode
    } = allData

    const updatePayHereData = (storeName, storeKey, value) => { // storeName[storeKey] = value
        updateSettings({ ...allData, [storeName]: { ...allData[storeName], [storeKey]: value } })
    }

    const clientIdDesc = __('Please register <a href="https://www.payhere.lk/account/signup/createaccount" target="__blank">here</a> to get Merchant ID and Secret Key.', 'wp-travel-payhere');

    return (
        <>
            {
                wt_test_mode === 'yes' ?
                <strong><p className="howTo" style={{color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen'}} >{ _wp_travel.setting_strings.payment.test_mode_active }</p></strong>
                : <strong><p className="howTo" style={{color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen'}} >{ _wp_travel.setting_strings.payment.live_mode_active }</p></strong>
            }
            <PanelRow>
                <label>{ _wp_travel.setting_strings.payment.enable_payhere }</label>
                <div className="wp-travel-field-value">
                    <ToggleControl
                        checked={ 'undefined' != typeof wp_travel_payhere_settings && wp_travel_payhere_settings.payment_option_payhere == 'yes' }
                        onChange={
                            (value) => {
                                updatePayHereData( 'wp_travel_payhere_settings', 'payment_option_payhere', 'undefined' != typeof wp_travel_payhere_settings && 'yes' == wp_travel_payhere_settings.payment_option_payhere ? 'no': 'yes' );
                            }
                        }
                    />
                    <p className="description">{_wp_travel.setting_strings.payment.enable_payhere_note}</p>
                </div>
            </PanelRow>

            {
                'undefined' != typeof wp_travel_payhere_settings && wp_travel_payhere_settings.payment_option_payhere === 'yes' &&
                <>
                    <PanelRow>
                        <label>{ _wp_travel.setting_strings.payment.payhere_merchant_id }</label>
                            <div className="wp-travel-field-value">
                                <TextControl
                                    value={ 'undefined' !== typeof wp_travel_payhere_settings.merchant_id ? wp_travel_payhere_settings.merchant_id : '' }
                                    onChange={
                                        (value) => {
                                            updatePayHereData( 'wp_travel_payhere_settings', 'merchant_id', value );
                                        }
                                    }
                                />
                                <p className="description" dangerouslySetInnerHTML={{ __html: clientIdDesc }}></p>
                            </div>
                    </PanelRow>

                    <PanelRow>
                        <label>{ _wp_travel.setting_strings.payment.payhere_merchant_seceret }</label>
                            <div className="wp-travel-field-value">
                                <TextControl
                                    value={ 'undefined' !== typeof wp_travel_payhere_settings.merchant_secret ? wp_travel_payhere_settings.merchant_secret : '' }
                                    onChange={
                                        (value) => {
                                            updatePayHereData( 'wp_travel_payhere_settings', 'merchant_secret', value );
                                        }
                                    }
                                />
                            </div>
                    </PanelRow>

                </>
            }
        </>
    )
}